import React from 'react';
import { useThumbs } from '../../../hook/useThumbs';
import { getPlatform, Platform } from '../../../util/platform';

export interface RowVirtualizer {
  getTotalSize: () => number;
}
interface CustomScrollWrapperProps {
  children: React.ReactNode;
  scrollRef: React.RefObject<HTMLDivElement>;
  rowVirtualizer?: RowVirtualizer;
}

const CustomScrollWrapper: React.FC<CustomScrollWrapperProps> = ({ children, scrollRef, rowVirtualizer }) => {
  const platform = getPlatform();
  const ios = platform === Platform.IOS;

  const totalSize = rowVirtualizer?.getTotalSize?.() ?? 0;
  const { vThumbRef, hThumbRef } = useThumbs({ scrollRef, totalSize, ios });

  if (!ios) return <>{children}</>;

  return (
    <div className="custom_scroll_wrapper">
      {children}
      <div className="custom_scroll_thumb custom_scroll_thumb_vertical" ref={vThumbRef} />
      <div className="custom_scroll_thumb custom_scroll_thumb_horizontal" ref={hThumbRef} />
    </div>
  );
};

export default CustomScrollWrapper;
